<template>
  <div class="lis-text-left" @click="onClick">
    <div class="check-select">
      <div class="income-banner">
        <img v-if="imageName" :src="getImgUrl(imageName)" alt="image"
             class="check-icon" :class="{ 'article': ($template === 'article') }">
      </div>
      <div class="check-select-label" :class="{ 'article': ($template === 'article') }">
        <p>
          {{ label }}
          <span v-if="tooltip" class="tooltip-icon" v-tooltip="tooltip">
            <img src="//hm-lis.herokuapp.com/img/svg/info-circle-solid.svg" alt="image">
          </span>
        </p>
      </div>
    </div>
    <div class="check-select-items">
      <div class="bullets">
        <div class="bullet">
          <SuiIcon v-if="isChecked" name="check circle" color="green"/>
          <SuiIcon v-else name="circle outline" color="grey"/>
          <span>{{ yes }}</span>
        </div>
        
        <div class="bullet">
          <SuiIcon v-if="!isChecked" name="check circle" color="green"/>
          <SuiIcon v-else name="circle outline" color="grey"/>
          <span>{{ no }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {Icon} from 'semantic-ui-vue/dist/commonjs/elements/Icon';

  export default {
    name: 'CheckSelectInput',
    components: {
      SuiIcon: Icon,
    },
    props: {
      value: {type: Boolean, default: () => false},
      imageName: {type: String, default: () => ''},
      label: {type: String, default: () => ''},
      tooltip: {type: String, default: () => ''},
      yes: {type: String, default: () => 'Yes.'},
      no: {type: String, default: () => 'No.'},
    },
    beforeMount() {
      this.$data.isChecked = this.$props.value;
    },
    watch: {
      value(newVal) {
        this.$data.isChecked = newVal;
      },
    },
    data() {
      return {
        isChecked: false,
      }
    },
    methods: {
      getImgUrl(imageName) {
        return 'https://hm-lis.herokuapp.com/img/svg/' + imageName;
      },
      onClick() {
        this.$data.isChecked = !this.$data.isChecked;
        this.$emit('input', this.$data.isChecked);
      },
    },
  }
</script>

<style lang="scss" scoped>
  .check-select-items {
    display: flex;
    justify-content: center;
    .bullets {
      margin-top: 1rem;
      text-align: left;
      .bullet {
        margin-top: .8rem;
      }
    }
  }
  div.lis-text-left {
    margin: 0;
    cursor: pointer;
    width: 100%;

    p {
      font-weight: bolder;
      margin-bottom: .5em;
    }

    i {
      margin-right: .5em;
    }

    .article {
      .bullet {
        margin-left: 0;
      }
    }
  }
</style>
